export default "__VITE_ASSET__BnwfFP8r__"